module.exports = __webpack_public_path__ + "img/bentu.e7c57bf9.png";